export const en_es: any = {
  countryCode: 'Código de País',
  provinceCode: 'Código de Provincias',
  municipalityCode: 'Código de municipio',
  sectorCode: 'Código de Sector',
  description: 'Descripción',
  transactionKnowledge: 'Conocimiento de Transacción',
  economicCapacity: 'Capacidad Económica',
  comprehension: 'Conocimiento de la transacción',
  riskTolerance: 'Tolerancia a Riegos',
  typeRiskAssume: 'Tipo de Riesgo dispuesto a asumir',
  clasification: 'Clasificación',
  capacityFinancialUnderstanding: 'Capacidad comprensión Financiera',
  capacityEconomicIntegral: 'Capacidad Económica Integral',
  name: 'Nombre',
  elements: 'Elementos',
  createDate: 'Fecha de Creación',
  updateDate: 'Fecha de Actualización',
  tipeRiskAssume: 'Tipo de Riesgo Asumido',
  typeRiskWillingAssume: 'Tipo Riesgo Dispuesto Asumir',
  capacityFinanceUnderstanding: 'Capacidad de comprensión Financiera',  
  username: 'Correo electrónico',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Teléfono',
  activationCode: 'Código de Activación',
  password: 'Contraseña',
  country: 'País',
  probability	: 'Probabilidad',
  impact: 'Impacto',
  inherentRisk: 'Riesgo inherente',
  userRole: 'Rol de Usuario',
  status: 'Estado',
  
  
  
  createdAt: 'Fecha de Creación',
  // tableName: 'Nombre',
  numberData: 'Elementos',
  modified: 'Fecha de Actualización',
  firsname: 'Nombre',
  formtype: 'Tipo de Cuenta',
  weight: 'Peso',
  stepForm: 'Paso completado',
  risk: 'Leyenda de Riesgo',
  category: 'Categoría',
  code: 'Código',
  branchOffice: 'Sucursal'
}

export const en_esKeys = Object.keys(en_es)
